"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = exports.MAP_RULE_PREFIX = void 0;
exports.MAP_RULE_PREFIX = 'map';
var Map;
(function (Map) {
    Map["View"] = "map:view";
    Map["AllHabitats"] = "map:allHabitats";
})(Map || (exports.Map = Map = {}));
